import React from 'react';
import Icon from '../icons/Icon';
import LinkAnchor from '../../element/link/LinkAnchor';
import { sanitiseUrl } from '../../../common/utils/urlUtil';

import './MediaOverlayButton.scss';

type Props = {
    iconName: string;
    onClick?: (event: any) => void;
    url?: string;
};

const MediaOverlayButton = ({ iconName = 'magnifying-glass', onClick, url }: Props) => {
    const buttonContent = url ? (
        <LinkAnchor url={sanitiseUrl(url)}>
            <Icon name={iconName} />
        </LinkAnchor>
    ) : (
        <Icon name={iconName} />
    );

    return (
        <div className="MediaOverlayButton" onClick={onClick}>
            {buttonContent}
        </div>
    );
};

export default MediaOverlayButton;
